export default "__VITE_ASSET__xdlX_sUC__"